module.exports = __webpack_public_path__ + "img/xBlack.14ce4b20.gif";